import { AccountProvider } from "./lib/AccountProvider.tsx";
import { AppRoutes } from "./routes/AppRoutes.tsx";

/**
 * The session, then the route table.
 *
 * Both live one level down: `AccountProvider` so every route resolves the same
 * caller without refetching, `AppRoutes` so there is exactly one place that
 * says what an address means.
 */
export function App() {
  return (
    <AccountProvider>
      <AppRoutes />
    </AccountProvider>
  );
}
